
window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

// Módulos migrados para o Supabase. LocalStorage removido.

// PAGE: Sistema
window.FazendaRP.Pages.sistema = {
    render: function (container) {
        container.innerHTML = `
            <div id="sistema-module">
                
                <!-- Submenu Interno (Barra de Ferramentas) -->
                <div class="submenu-container" style="flex-wrap: wrap;">
                    <div class="submenu-item active" data-tab="parceiros"><i class="fas fa-users"></i> Parceiros</div>
                    <div class="submenu-item" data-tab="empresas"><i class="fas fa-building"></i> Empresas</div>
                    <div class="submenu-item" data-tab="usuarios"><i class="fas fa-user-shield"></i> Usuários</div>
                    <div class="submenu-item" data-tab="safras"><i class="fas fa-seedling"></i> Safras</div>
                    <div class="submenu-item" data-tab="variedades"><i class="fas fa-leaf"></i> Variedades</div>
                    <div class="submenu-item" data-tab="configuracoes"><i class="fas fa-cogs"></i> Configurações</div>
                    <div class="submenu-item" data-tab="audit"><i class="fas fa-history"></i> Auditoria</div>
                    <div class="submenu-item" data-tab="backup"><i class="fas fa-download"></i> Backup & Dados</div>
                </div>

                <!-- Header de Título -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                    <h2 id="sistema-page-title" style="margin:0;">Gestão de Parceiros</h2> 
                </div>

                <!-- Área de Conteúdo das Abas -->
                <div id="sistema-content">
                    <!-- O conteúdo muda aqui -->
                </div>
            </div>
        `;

        // Gerenciar cliques no submenu
        const tabs = container.querySelectorAll('.submenu-item[data-tab]');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                const pageTitle = document.getElementById('sistema-page-title');
                if (pageTitle) {
                    if (tab.dataset.tab === 'parceiros') pageTitle.innerText = "Gestão de Parceiros";
                    else if (tab.dataset.tab === 'empresas') pageTitle.innerText = "Minhas Empresas";
                    else if (tab.dataset.tab === 'safras') pageTitle.innerText = "Gestão de Safras";
                    else if (tab.dataset.tab === 'variedades') pageTitle.innerText = "Catálogo de Variedades";
                    else if (tab.dataset.tab === 'usuarios') pageTitle.innerText = "Usuários do Sistema";
                    else if (tab.dataset.tab === 'configuracoes') pageTitle.innerText = "Configurações Gerais";
                    else pageTitle.innerText = tab.innerText;
                }

                const tabName = tab.dataset.tab;
                this.renderTabContent(tabName);
            });
        });

        // Renderizar aba padrão
        this.renderTabContent('parceiros');
    },

    renderTabContent: function (tabName) {
        const contentContainer = document.getElementById('sistema-content');

        if (tabName === 'parceiros') {
            this.renderListaParceiros(contentContainer);
        } else if (tabName === 'empresas') {
            this.renderListaEmpresas(contentContainer);
        } else if (tabName === 'safras') {
            this.renderListaSafras(contentContainer);
        } else if (tabName === 'variedades') {
            if (window.FazendaRP.Pages.sistema.renderListaVariedades) {
                window.FazendaRP.Pages.sistema.renderListaVariedades(contentContainer);
            } else {
                contentContainer.innerHTML = '<div style="padding:20px;">Carregando módulo de variedades...</div>';
            }
        } else if (tabName === 'configuracoes') {
            this.renderListaUsuarios(contentContainer);
        } else if (tabName === 'backup') {
            this.renderBackupSection(contentContainer);
        } else {
            contentContainer.innerHTML = `
                <div class="card" style="text-align: center; padding: 40px; color: var(--text-muted);">
                    <i class="fas fa-tools fa-2x" style="margin-bottom: 15px;"></i>
                    <h3>Em Construção: ${tabName}</h3>
                    <p>Esta funcionalidade do sistema será liberada em breve.</p>
                </div>
            `;
        }
    },

    // --- SUB-TELA: Lista de Parceiros (SUPABASE) ---

    loadParceiros: async function () {
        const { data, error } = await window.FazendaRP.supabase
            .from('parceiros')
            .select('*')
            .order('nome');

        if (error) {
            console.error("Erro ao carregar parceiros:", error);
            return [];
        }
        return data;
    },

    maskCpfCnpj: function (val) {
        val = val.replace(/\D/g, "");
        if (val.length > 14) val = val.substring(0, 14);

        if (val.length <= 11) {
            val = val.replace(/(\d{3})(\d)/, "$1.$2");
            val = val.replace(/(\d{3})(\d)/, "$1.$2");
            val = val.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
            val = val.replace(/^(\d{2})(\d)/, "$1.$2");
            val = val.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
            val = val.replace(/\.(\d{3})(\d)/, ".$1/$2");
            val = val.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return val;
    },

    validarCpfCnpj: function (val) {
        if (!val) return false;

        // Remove tudo que não é dígito
        const str = val.replace(/\D/g, '');

        // Validação de CPF
        if (str.length === 11) {
            if (/^(\d)\1{10}$/.test(str)) return false; // Bloqueia 111.111.111-11

            let soma = 0;
            let resto;
            for (let i = 1; i <= 9; i++) soma = soma + parseInt(str.substring(i - 1, i)) * (11 - i);
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) resto = 0;
            if (resto !== parseInt(str.substring(9, 10))) return false;

            soma = 0;
            for (let i = 1; i <= 10; i++) soma = soma + parseInt(str.substring(i - 1, i)) * (12 - i);
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) resto = 0;
            if (resto !== parseInt(str.substring(10, 11))) return false;

            return true;
        }

        // Validação de CNPJ
        else if (str.length === 14) {
            if (/^(\d)\1{13}$/.test(str)) return false; // Bloqueia 11.111.111/1111-11

            let tamanho = str.length - 2;
            let numeros = str.substring(0, tamanho);
            let digitos = str.substring(tamanho);
            let soma = 0;
            let pos = tamanho - 7;

            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }

            let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;

            tamanho = tamanhoe + 1;
            numeros = str.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;

            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) return false;

            return true;
        }

        return false;
    },

    renderListaParceiros: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:50px; color:#666;"><i class="fas fa-spinner fa-spin"></i> Carregando lista de parceiros...</div>';

        const parceirosData = await this.loadParceiros();

        // Estrutura Base
        container.innerHTML = `
            <div class="data-table-container">
                <div class="action-bar" style="display:flex; align-items:center; gap:15px; flex-wrap:wrap;">
                    
                    <!-- Busca com Ícone -->
                    <div style="position:relative; flex:1; min-width:250px;">
                        <i class="fas fa-search" style="position:absolute; left:12px; top:50%; transform:translateY(-50%); color:#9ca3af;"></i>
                        <input type="text" id="filtro-busca" placeholder="Buscar parceiro..." style="width:100%; padding:10px 10px 10px 35px; border:1px solid #e5e7eb; border-radius:8px; outline:none; font-size:0.95rem;">
                    </div>

                    <!-- Filtro Categoria com Ícone -->
                    <div style="position:relative; width: 220px;">
                        <i class="fas fa-filter" style="position:absolute; left:12px; top:50%; transform:translateY(-50%); color:#9ca3af;"></i>
                        <select id="filtro-categoria" style="width:100%; padding:10px 10px 10px 35px; border:1px solid #e5e7eb; border-radius:8px; outline:none; background:white; cursor:pointer; font-size:0.95rem; appearance:none;">
                            <option value="">Todas as Categorias</option>
                            <option value="Cliente">Clientes</option>
                            <option value="Fornecedor">Fornecedores</option>
                            <option value="Funcionário">Funcionários</option>
                        </select>
                        <i class="fas fa-chevron-down" style="position:absolute; right:12px; top:50%; transform:translateY(-50%); color:#9ca3af; pointer-events:none; font-size:0.8rem;"></i>
                    </div>

                    <label style="display:flex; align-items:center; gap:6px; cursor:pointer; user-select:none; font-size:0.9rem; color:#4b5563; margin-left: auto; margin-right: 15px;">
                        <input type="checkbox" id="chk-mostrar-inativos" style="width:16px; height:16px;"> Mostrar Inativos
                    </label>

                    <div style="flex:0 0 auto;">
                         <button class="btn btn-primary" id="btn-novo-parceiro" style="display:flex; align-items:center; gap:8px;"><i class="fas fa-plus"></i> Novo Parceiro</button>
                    </div>
                </div>
                
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Categoria</th>
                            <th>CPF / CNPJ</th>
                            <th>Status</th>
                            <th style="text-align: right;">Ações</th>
                        </tr>
                    </thead>
                    <tbody id="tabela-parceiros-body">
                        <!-- Linhas geradas via JS -->
                    </tbody>
                </table>
            </div>
            <div id="modal-container-parceiro"></div>
        `;

        // Função de Renderizar Linhas (Filtragem)
        const renderRows = (lista) => {
            const tbody = document.getElementById('tabela-parceiros-body');
            if (lista.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; color: #777; padding: 40px;">Nenhum parceiro encontrado para os filtros selecionados.</td></tr>';
                return;
            }

            tbody.innerHTML = lista.map(p => {
                // Suporte a múltiplas categorias (string separada por vírgula)
                const categorias = p.categoria ? p.categoria.split(',') : ['Geral'];

                const catBadges = categorias.map(c => {
                    const cat = c.trim();
                    let bg = '#f3f4f6'; let color = '#374151';
                    if (cat === 'Cliente') { bg = '#dbeafe'; color = '#1e40af'; }
                    else if (cat === 'Fornecedor') { bg = '#dcfce7'; color = '#166534'; }
                    else if (cat === 'Funcionário') { bg = '#fce7f3'; color = '#9d174d'; }
                    return `<span style="background:${bg}; color:${color}; border-radius: 6px; padding: 4px 10px; font-weight:600; font-size:0.85rem; display:inline-block; margin-right:4px;">${cat}</span>`;
                }).join('');

                const statusColor = p.status === 'Inativo' ? '#ef4444' : '#10b981';

                // Usar Nome Fantasia se disponível para exibição principal
                const nomePrincipal = p.nome_fantasia ? p.nome_fantasia : p.nome;
                const nomeSecundario = p.nome_fantasia ? p.nome : '';

                const isInativo = p.status === 'Inativo';
                const btnAction = isInativo
                    ? `<button class="btn-icon-toggle" data-id="${p.id}" data-action="ativar" style="border:none; background:none; cursor:pointer; color:#10b981; font-size:1.1rem; transition:color 0.2s;" title="Reativar Parceiro"><i class="fas fa-check-circle"></i></button>`
                    : `<button class="btn-icon-toggle" data-id="${p.id}" data-action="inativar" style="border:none; background:none; cursor:pointer; color:#ef4444; font-size:1.1rem; transition:color 0.2s;" title="Inativar Parceiro"><i class="fas fa-ban"></i></button>`;

                return `
                <tr style="transition: background 0.2s; opacity: ${isInativo ? '0.6' : '1'};">
                    <td>
                        <div style="font-weight:600; color:#1f2937; font-size:1rem;">${nomePrincipal}</div>
                        ${nomeSecundario ? `<div style="font-size:0.85rem; color:#6b7280; margin-top:2px;">${nomeSecundario}</div>` : ''}
                        <div style="font-size:0.85rem; color:#6b7280; margin-top:2px;">${p.obs || ''}</div>
                    </td>
                    <td>${catBadges}</td>
                    <td style="font-family:'Courier New', monospace; color:#374151; font-weight:500;">${p.cpf_cnpj || '-'}</td>
                    <td>
                        <div style="display:flex; align-items:center; font-size:0.9rem;">
                            <span style="display:inline-block; width:8px; height:8px; background:${statusColor}; border-radius:50%; margin-right:8px;"></span>
                            ${p.status || 'Ativo'}
                        </div>
                    </td>
                    <td style="text-align: right;">
                        <button class="btn-icon-edit" data-id="${p.id}" style="border:none; background:none; cursor:pointer; color:#6b7280; margin-right:12px; font-size:1.1rem; transition:color 0.2s;" title="Editar"><i class="fas fa-edit"></i></button>
                        ${btnAction}
                    </td>
                </tr>
                `;
            }).join('');

            // Listeners nas rows novas
            tbody.querySelectorAll('.btn-icon-edit').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    // Impede bolha pra não clicar na row se tiver click event na tr
                    e.stopPropagation();
                    this.openEditarParceiroModal(parseInt(e.currentTarget.dataset.id));
                });
            });

            tbody.querySelectorAll('.btn-icon-toggle').forEach(btn => {
                btn.addEventListener('click', async (e) => {
                    e.stopPropagation();
                    const id = parseInt(e.currentTarget.dataset.id);
                    const action = e.currentTarget.dataset.action;

                    const novoStatus = action === 'ativar' ? 'Ativo' : 'Inativo';
                    const confirmMsg = action === 'ativar'
                        ? 'Deseja reativar este parceiro?'
                        : 'Deseja inativar este parceiro? Ele será ocultado das listas padrões, mas o histórico é mantido.';

                    if (confirm(confirmMsg)) {
                        const { error } = await window.FazendaRP.supabase
                            .from('parceiros')
                            .update({ status: novoStatus })
                            .eq('id', id);

                        if (error) window.FazendaRP.Toast.show('error', 'Erro', "Erro ao atualizar: " + error.message);
                        else {
                            window.FazendaRP.Toast.show('success', 'Sucesso', `Parceiro ${novoStatus === 'Ativo' ? 'reativado' : 'inativado'}.`);
                            this.renderListaParceiros(container);
                        }
                    }
                });
            });
        };

        // Lógica de Filtro
        const inputBusca = document.getElementById('filtro-busca');
        const selectCategoria = document.getElementById('filtro-categoria');
        const checkInativos = document.getElementById('chk-mostrar-inativos');

        const aplicarFiltros = () => {
            const termo = inputBusca.value.toLowerCase().trim();
            const cat = selectCategoria.value;
            const showInativos = checkInativos.checked;

            const filtrados = parceirosData.filter(p => {
                const termoMatch = p.nome.toLowerCase().includes(termo) ||
                    (p.nome_fantasia && p.nome_fantasia.toLowerCase().includes(termo)) ||
                    (p.cpf_cnpj && p.cpf_cnpj.includes(termo));

                // Filtro de categoria checa se a string de categorias CONTÉM a categoria selecionada
                const catMatch = cat === "" || (p.categoria && p.categoria.includes(cat));
                const statusMatch = showInativos ? true : p.status !== 'Inativo';

                return termoMatch && catMatch && statusMatch;
            });

            renderRows(filtrados);
        };

        inputBusca.addEventListener('input', aplicarFiltros);
        selectCategoria.addEventListener('change', aplicarFiltros);
        checkInativos.addEventListener('change', aplicarFiltros);

        // Render Inicial (Via Filtro)
        aplicarFiltros();

        // Botão Novo
        const btnNovo = document.getElementById('btn-novo-parceiro');
        if (btnNovo) btnNovo.addEventListener('click', () => this.openNovoParceiroModal());
    },

    openNovoParceiroModal: function (onSuccess = null, preFillData = null) {
        let modalContainer = document.getElementById('modal-container-parceiro');
        if (!modalContainer) {
            modalContainer = document.createElement('div');
            modalContainer.id = 'modal-container-parceiro';
            document.body.appendChild(modalContainer);
        }

        modalContainer.innerHTML = `
            <div class="modal-overlay" id="modal-overlay-parc" style="z-index: 9999;">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Novo Parceiro</h3>
                        <button class="modal-close" id="modal-close-parc">&times;</button>
                    </div>
                    
                    <form id="form-novo-parceiro">
                        <div class="form-group" style="margin-bottom: 25px;">
                            <label style="margin-bottom: 12px; display: block; font-weight:500;">Categoria / Tipo</label>
                            <div class="chip-toggle-group" id="cat-options">
                                <div class="chip-toggle" data-value="Cliente">
                                    <span>👤</span> Cliente
                                </div>
                                <div class="chip-toggle" data-value="Fornecedor">
                                    <span>📦</span> Fornecedor
                                </div>
                                <div class="chip-toggle" data-value="Funcionário">
                                    <span>👷</span> Funcionário
                                </div>
                            </div>
                            <input type="hidden" id="cat-selected" required>
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">CPF / CNPJ</label>
                            <input type="text" id="doc-parceiro" style="width: 100%;" placeholder="000.000.000-00" class="form-control">
                            <small id="doc-error" style="color:red; display:none; font-size:0.85rem; margin-top:5px;">Documento inválido!</small>
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Nome Fantasia (Opcional)</label>
                            <input type="text" id="fantasia-parceiro" style="width: 100%;" class="form-control" placeholder="Como é conhecido...">
                        </div>
                        
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Razão Social / Nome Completo *</label>
                            <input type="text" id="nome-parceiro" required style="width: 100%;" class="form-control">
                        </div>
                        
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Inscrição Estadual (Opcional)</label>
                            <input type="text" id="ie-parceiro" style="width: 100%;" class="form-control">
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Observações</label>
                            <textarea id="obs-parceiro" rows="2" style="width: 100%;" class="form-control" placeholder="Dados adicionais..."></textarea>
                        </div>
                        
                        <div style="display: flex; justify-content: flex-end; margin-top: 30px;">
                            <button type="submit" class="btn btn-primary" id="btn-salvar-parc" style="width: 100%;">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        const overlay = document.getElementById('modal-overlay-parc');
        const closeModal = () => modalContainer.innerHTML = '';

        document.getElementById('modal-close-parc').onclick = closeModal;
        overlay.onclick = (e) => { if (e.target === overlay) closeModal(); };

        // Toggle Chips (Multi-select)
        const catOptions = document.getElementById('cat-options').querySelectorAll('.chip-toggle');
        const catInput = document.getElementById('cat-selected');

        catOptions.forEach(opt => {
            opt.onclick = () => {
                opt.classList.toggle('active');

                const selected = [];
                catOptions.forEach(o => {
                    if (o.classList.contains('active')) selected.push(o.dataset.value);
                });
                catInput.value = selected.join(',');
            };
        });

        // Force Uppercase on Name
        const inpName = document.getElementById('nome-parceiro');
        if (inpName) {
            inpName.addEventListener('input', (e) => {
                e.target.value = e.target.value.toUpperCase();
            });
        }

        // Pre-fill Data Logic
        if (preFillData) {
            if (preFillData.nome) inpName.value = preFillData.nome.toUpperCase();
            if (preFillData.doc) {
                const rawDoc = preFillData.doc;
                const docInput = document.getElementById('doc-parceiro');
                docInput.value = this.maskCpfCnpj(rawDoc);
            }

            // Auto Select 'Fornecedor' if presumed from XML
            const fornChip = document.querySelector('.chip-toggle[data-value="Fornecedor"]');
            if (fornChip) {
                fornChip.classList.add('active');
                catInput.value = 'Fornecedor';
            }
        }

        // Mask & Live Validation
        const docInput = document.getElementById('doc-parceiro');
        const docError = document.getElementById('doc-error');

        docInput.addEventListener('input', async (e) => {
            let val = e.target.value;
            e.target.value = this.maskCpfCnpj(val);

            const raw = val.replace(/\D/g, '');
            if (raw.length === 14) {
                // Feedback visual
                docInput.style.borderColor = '#3b82f6';
                const originalPlaceholder = docInput.placeholder;

                try {
                    const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${raw}`);
                    if (response.ok) {
                        const data = await response.json();

                        // Auto-fill
                        const nomeInput = document.getElementById('nome-parceiro');
                        const fantasiaInput = document.getElementById('fantasia-parceiro');
                        const ieInput = document.getElementById('ie-parceiro'); // Opcional se vier da API? BrasilAPI não traz IE consistentemente, mas traz Address.

                        if (nomeInput && !nomeInput.value) nomeInput.value = data.razao_social || '';
                        if (fantasiaInput && !fantasiaInput.value) fantasiaInput.value = data.nome_fantasia || data.razao_social || '';

                        // Auto select "Fornecedor" if "cnae_fiscal_descricao" suggests it? Too risky. Keep manual.

                        window.FazendaRP.Toast.show('success', 'CNPJ Encontrado', 'Dados da empresa carregados.');
                    }
                } catch (err) {
                    console.log("BrasilAPI Error", err);
                    // Silent fail or small notification? Silent is better for UX if just typing.
                } finally {
                    docInput.style.borderColor = '';
                }
            }
        });

        // Save
        document.getElementById('form-novo-parceiro').onsubmit = async (e) => {
            e.preventDefault();
            const btn = document.getElementById('btn-salvar-parc');
            const docVal = docInput.value.replace(/\D/g, '');

            if (!catInput.value) { window.FazendaRP.Toast.show('warning', 'Atenção', "Selecione uma categoria."); return; }

            // Verifica se o CPF/CNPJ é válido (se preenchido)
            if (docVal.length > 0) {
                if (!this.validarCpfCnpj(docInput.value)) {
                    docError.style.display = 'block';
                    docError.innerText = "CPF ou CNPJ inválido. Verifique os números.";
                    docInput.focus();
                    return;
                } else {
                    docError.style.display = 'none';

                    // Check Duplicidade
                    const { data: existing } = await window.FazendaRP.supabase
                        .from('parceiros')
                        .select('id')
                        .eq('cpf_cnpj', docInput.value)
                        .maybeSingle();

                    if (existing) {
                        window.FazendaRP.Toast.show('warning', 'Duplicidade', "Já existe um parceiro cadastrado com este Documento.");
                        docInput.focus();
                        return;
                    }
                }
            }

            const payload = {
                nome: document.getElementById('nome-parceiro').value,
                nome_fantasia: document.getElementById('fantasia-parceiro').value,
                cpf_cnpj: docInput.value,
                inscricao_estadual: document.getElementById('ie-parceiro').value,
                categoria: catInput.value,
                status: 'Ativo',
                obs: document.getElementById('obs-parceiro').value
            };

            btn.innerText = "Salvando...";
            btn.disabled = true;

            const { data, error } = await window.FazendaRP.supabase.from('parceiros').insert([payload]).select();

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', "Erro: " + error.message);
                btn.innerText = "Salvar";
                btn.disabled = false;
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', "Salvo com sucesso!");
                closeModal();
                // Se houver callback (chamado do financeiro), executa
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess(data ? data[0] : payload);
                } else {
                    // Senão, atualiza grid se existir
                    const content = document.getElementById('sistema-content');
                    if (content) this.renderListaParceiros(content);
                }
            }
        };
    },

    openEditarParceiroModal: async function (id) {
        const { data: parceiro, error } = await window.FazendaRP.supabase
            .from('parceiros')
            .select('*')
            .eq('id', id)
            .single();

        if (error || !parceiro) {
            window.FazendaRP.Toast.show('error', 'Erro', "Erro ao buscar dados.");
            return;
        }

        const modalContainer = document.getElementById('modal-container-parceiro');
        modalContainer.innerHTML = `
            <div class="modal-overlay" id="modal-overlay-parc">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Editar Parceiro</h3>
                        <button class="modal-close" id="modal-close-parc">&times;</button>
                    </div>
                    
                    <form id="form-editar-parceiro">
                        <div class="form-group" style="margin-bottom: 25px;">
                            <label style="margin-bottom: 12px; display: block; font-weight:500;">Categoria</label>
                            <div class="chip-toggle-group" id="cat-options">
                                <div class="chip-toggle ${(parceiro.categoria || '').includes('Cliente') ? 'active' : ''}" data-value="Cliente"><span>👤</span> Cliente</div>
                                <div class="chip-toggle ${(parceiro.categoria || '').includes('Fornecedor') ? 'active' : ''}" data-value="Fornecedor"><span>📦</span> Fornecedor</div>
                                <div class="chip-toggle ${(parceiro.categoria || '').includes('Funcionário') ? 'active' : ''}" data-value="Funcionário"><span>👷</span> Funcionário</div>
                            </div>
                            <input type="hidden" id="cat-selected" value="${parceiro.categoria || ''}">
                        </div>
                        
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>Nome Fantasia (Opcional)</label>
                            <input type="text" id="fantasia-parceiro" style="width: 100%;" class="form-control" value="${parceiro.nome_fantasia || ''}" placeholder="Como é conhecido...">
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>Razão Social / Nome Completo *</label>
                            <input type="text" id="nome-parceiro" required style="width: 100%;" class="form-control" value="${parceiro.nome}">
                        </div>
                        
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>CPF / CNPJ</label>
                            <input type="text" id="doc-parceiro" style="width: 100%;" class="form-control" value="${parceiro.cpf_cnpj || ''}">
                            <small id="doc-error-edit" style="color:red; display:none; font-size:0.85rem; margin-top:5px;">Documento inválido!</small>
                        </div>
                        
                         <div class="form-group" style="margin-bottom: 20px;">
                            <label>Inscrição Estadual</label>
                            <input type="text" id="ie-parceiro" style="width: 100%;" class="form-control" value="${parceiro.inscricao_estadual || ''}">
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>Status</label>
                            <select id="status-parceiro" class="form-control" style="width:100%">
                                <option value="Ativo" ${parceiro.status === 'Ativo' ? 'selected' : ''}>Ativo</option>
                                <option value="Inativo" ${parceiro.status === 'Inativo' ? 'selected' : ''}>Inativo</option>
                            </select>
                        </div>

                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>Observações</label>
                            <textarea id="obs-parceiro" rows="2" style="width: 100%;" class="form-control">${parceiro.obs || ''}</textarea>
                        </div>
                        
                        <div style="margin-top: 10px; font-size: 0.8rem; color: #9ca3af; text-align: right;">
                            ${parceiro.updated_at ? 'Última atualização: ' + new Date(parceiro.updated_at).toLocaleString('pt-BR') : ''}
                        </div>
                        
                        <div style="display: flex; justify-content: flex-end; margin-top: 30px;">
                            <button type="submit" class="btn btn-primary" id="btn-salvar-parc" style="width: 100%;">Atualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        const overlay = document.getElementById('modal-overlay-parc');
        const closeModal = () => modalContainer.innerHTML = '';
        document.getElementById('modal-close-parc').onclick = closeModal;
        overlay.onclick = (e) => { if (e.target === overlay) closeModal(); };

        const catOptions = document.getElementById('cat-options').querySelectorAll('.chip-toggle');
        const catInput = document.getElementById('cat-selected');
        catOptions.forEach(opt => {
            opt.onclick = () => {
                opt.classList.toggle('active');

                const selected = [];
                catOptions.forEach(o => {
                    if (o.classList.contains('active')) selected.push(o.dataset.value);
                });
                catInput.value = selected.join(',');
            };
        });

        const docInput = document.getElementById('doc-parceiro');
        const docError = document.getElementById('doc-error-edit');

        docInput.addEventListener('input', (e) => {
            e.target.value = this.maskCpfCnpj(e.target.value);
        });

        document.getElementById('form-editar-parceiro').onsubmit = async (e) => {
            e.preventDefault();
            const btn = document.getElementById('btn-salvar-parc');
            const docVal = docInput.value.replace(/\D/g, '');

            if (docVal.length > 0) {
                if (!this.validarCpfCnpj(docInput.value)) {
                    docError.style.display = 'block';
                    docError.innerText = "CPF ou CNPJ inválido.";
                    docInput.focus();
                    return;
                } else {
                    docError.style.display = 'none';
                }
            }

            const payload = {
                nome: document.getElementById('nome-parceiro').value,
                nome_fantasia: document.getElementById('fantasia-parceiro').value,
                cpf_cnpj: docInput.value,
                inscricao_estadual: document.getElementById('ie-parceiro').value,
                categoria: catInput.value,
                status: document.getElementById('status-parceiro').value,
                obs: document.getElementById('obs-parceiro').value
            };

            btn.innerText = "Atualizando...";
            btn.disabled = true;

            const { error } = await window.FazendaRP.supabase
                .from('parceiros')
                .update(payload)
                .eq('id', id);

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', "Erro: " + error.message);
                btn.innerText = "Atualizar";
                btn.disabled = false;
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', "Atualizado com sucesso!");
                closeModal();
                this.renderListaParceiros(document.getElementById('sistema-content'));
            }
        };
    },

    // Validar CPF/CNPJ (Algoritmo Oficial)
    validarCpfCnpj: function (val) {
        if (!val) return false;
        var s = val.replace(/\D/g, ''); // Remove mask

        // CPF
        if (s.length === 11) {
            if (/^(\d)\1{10}$/.test(s)) return false;
            var soma = 0, resto;
            for (var i = 1; i <= 9; i++) soma = soma + parseInt(s.substring(i - 1, i)) * (11 - i);
            resto = (soma * 10) % 11;
            if ((resto == 10) || (resto == 11)) resto = 0;
            if (resto != parseInt(s.substring(9, 10))) return false;
            soma = 0;
            for (var i = 1; i <= 10; i++) soma = soma + parseInt(s.substring(i - 1, i)) * (12 - i);
            resto = (soma * 10) % 11;
            if ((resto == 10) || (resto == 11)) resto = 0;
            if (resto != parseInt(s.substring(10, 11))) return false;
            return true;
        }

        // CNPJ
        else if (s.length === 14) {
            if (/^(\d)\1{13}$/.test(s)) return false;
            var tamanho = s.length - 2;
            var numeros = s.substring(0, tamanho);
            var digitos = s.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;

            tamanho = tamanho + 1;
            numeros = s.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) return false;

            return true;
        }

        return false;
    },

    // --- SUB-TELA: Lista de Empresas (Mantida LocalStorage) ---
    // --- SUB-TELA: Lista de Empresas (SUPABASE) ---
    renderListaEmpresas: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando empresas...</div>';

        const { data: empresas, error } = await window.FazendaRP.supabase
            .from('empresas')
            .select('*')
            .order('razao_social');

        if (error) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao carregar empresas.');
            return;
        }

        const rows = empresas.length ? empresas.map(e => `
            <tr>
                <td>${e.razao_social}</td>
                <td>${e.cpf_cnpj || '-'}</td>
                <td>${e.inscricao_estadual || '-'}</td>
                <td style="text-align: right;">
                    <i class="fas fa-edit" style="cursor:pointer; margin-right: 12px; color: #6b7280;" data-action="edit-empresa" data-id="${e.id}" title="Editar"></i>
                    <i class="fas fa-trash" style="cursor:pointer; color: var(--color-danger);" data-action="delete-empresa" data-id="${e.id}" title="Excluir"></i>
                </td>
            </tr>
        `).join('') : '<tr><td colspan="4" style="text-align: center; padding: 30px; color: #666;">Nenhuma empresa cadastrada</td></tr>';

        container.innerHTML = `
            <div style="margin-bottom: 15px; color: var(--text-muted); font-size: 0.9rem;">
                Minhas Empresas / Fazendas
            </div>
            <div class="data-table-container">
                <div class="action-bar">
                    <div></div>
                    <div><button class="btn btn-primary" id="btn-nova-empresa">+ Nova Empresa</button></div>
                </div>
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Razão Social / Nome</th>
                            <th>Documento (CPF/CNPJ)</th>
                            <th>Inscrição Estadual</th>
                            <th style="text-align: right;">Ações</th>
                        </tr>
                    </thead>
                    <tbody>${rows}</tbody>
                </table>
            </div>
            <div id="modal-container-empresa"></div>
        `;

        // Listeners
        container.querySelectorAll('[data-action="edit-empresa"]').forEach(btn => {
            btn.addEventListener('click', (e) => this.openEditarEmpresaModal(parseInt(e.target.dataset.id)));
        });

        container.querySelectorAll('[data-action="delete-empresa"]').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                const id = parseInt(e.target.dataset.id);
                if (confirm('Tem certeza que deseja excluir esta empresa?')) {
                    const { error } = await window.FazendaRP.supabase.from('empresas').delete().eq('id', id);
                    if (error) window.FazendaRP.Toast.show('error', 'Erro', error.message);
                    else {
                        window.FazendaRP.Toast.show('success', 'Sucesso', 'Empresa excluída.');
                        this.renderListaEmpresas(container);
                    }
                }
            });
        });

        document.getElementById('btn-nova-empresa').addEventListener('click', () => this.openNovaEmpresaModal());
    },

    openNovaEmpresaModal: function () {
        const modalContainer = document.getElementById('modal-container-empresa');
        modalContainer.innerHTML = `
            <div class="modal-overlay" id="modal-overlay-emp">
                <div class="modal-content" style="max-width: 500px;">
                    <div class="modal-header">
                        <h3 class="modal-title">Nova Empresa</h3>
                        <button class="modal-close" id="modal-close-emp">&times;</button>
                    </div>
                    <form id="form-nova-empresa">
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Razão Social / Nome *</label>
                            <input type="text" id="razao-social" required style="width: 100%;" class="form-control">
                        </div>
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">CPF / CNPJ</label>
                            <input type="text" id="doc-empresa" style="width: 100%;" class="form-control">
                        </div>
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Inscrição Estadual</label>
                            <input type="text" id="ie-empresa" style="width: 100%;" class="form-control">
                        </div>
                        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 30px;">
                            <button type="submit" class="btn btn-primary" id="btn-save-emp">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        document.getElementById('modal-close-emp').onclick = () => modalContainer.innerHTML = '';

        const docInput = document.getElementById('doc-empresa');
        docInput.addEventListener('input', (e) => e.target.value = this.maskCpfCnpj(e.target.value));

        const ieInput = document.getElementById('ie-empresa');
        if (ieInput) ieInput.addEventListener('input', (e) => e.target.value = e.target.value.replace(/[^0-9]/g, ''));

        document.getElementById('form-nova-empresa').onsubmit = async (e) => {
            e.preventDefault();
            const btn = document.getElementById('btn-save-emp');

            const payload = {
                razao_social: document.getElementById('razao-social').value,
                cpf_cnpj: docInput.value,
                inscricao_estadual: document.getElementById('ie-empresa').value
            };

            btn.disabled = true;
            btn.innerText = "Salvando...";

            const { error } = await window.FazendaRP.supabase.from('empresas').insert([payload]);

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', error.message);
                btn.disabled = false;
                btn.innerText = "Salvar";
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', "Empresa salva!");
                modalContainer.innerHTML = '';
                this.renderListaEmpresas(document.getElementById('sistema-content'));
            }
        };
    },

    openEditarEmpresaModal: async function (id) {
        const { data: empresa, error } = await window.FazendaRP.supabase
            .from('empresas').select('*').eq('id', id).single();

        if (error || !empresa) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Empresa não encontrada.');
            return;
        }

        const modalContainer = document.getElementById('modal-container-empresa');
        modalContainer.innerHTML = `
            <div class="modal-overlay" id="modal-overlay-emp">
                <div class="modal-content">
                    <div class="modal-header"><h3 class="modal-title">Editar Empresa</h3><button class="modal-close" id="modal-close-emp">&times;</button></div>
                    <form id="form-editar-empresa">
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Razão Social *</label>
                            <input type="text" id="razao" value="${empresa.razao_social}" required style="width:100%" class="form-control">
                        </div>
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">CPF / CNPJ</label>
                            <input type="text" id="doc-emp-edit" value="${empresa.cpf_cnpj || ''}" style="width:100%" class="form-control">
                        </div>
                         <div class="form-group" style="margin-bottom: 20px;">
                            <label style="font-weight:500;">Inscrição Estadual</label>
                            <input type="text" id="ie-emp-edit" value="${empresa.inscricao_estadual || ''}" style="width:100%" class="form-control">
                        </div>
                        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
                             <button type="submit" class="btn btn-primary" id="btn-upd-emp">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        document.getElementById('modal-close-emp').onclick = () => modalContainer.innerHTML = '';
        const docInput = document.getElementById('doc-emp-edit');
        docInput.addEventListener('input', (e) => e.target.value = this.maskCpfCnpj(e.target.value));

        const ieInput = document.getElementById('ie-emp-edit');
        if (ieInput) ieInput.addEventListener('input', (e) => e.target.value = e.target.value.replace(/[^0-9]/g, ''));

        document.getElementById('form-editar-empresa').onsubmit = async (e) => {
            e.preventDefault();
            const btn = document.getElementById('btn-upd-emp');
            const payload = {
                razao_social: document.getElementById('razao').value,
                cpf_cnpj: docInput.value,
                inscricao_estadual: document.getElementById('ie-emp-edit').value
            };

            btn.disabled = true; btn.innerText = "Salvando...";

            const { error } = await window.FazendaRP.supabase
                .from('empresas').update(payload).eq('id', id);

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', error.message);
                btn.disabled = false; btn.innerText = "Salvar";
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Dados atualizados!');
                modalContainer.innerHTML = '';
                this.renderListaEmpresas(document.getElementById('sistema-content'));
            }
        };
    },

    // --- SUB-TELA: Safras (Mantido) ---
    // --- SUB-TELA: Safras (SUPABASE) ---
    renderListaSafras: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando safras...</div>';

        const { data: safras, error } = await window.FazendaRP.supabase
            .from('safras').select('*').order('ano', { ascending: false });

        if (error) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao carregar safras.');
            return;
        }

        const rows = safras.map(s => `
            <tr>
                <td style="font-weight:600;">${s.ano}</td>
                <td>${s.cultura}</td>
                <td>${s.area_plantada ? s.area_plantada + ' ha' : '-'}</td>
                <td>${s.descricao || '-'}</td>
                <td style="text-align:right;">
                    <button class="btn btn-xs" style="background:#ecfdf5; color:#059669; border:1px solid #a7f3d0; margin-right:8px;" data-action="variedades-safra" data-id="${s.id}" data-ano="${s.ano}" data-cultura="${s.cultura}" data-area="${s.area_plantada || 0}">
                        <i class="fas fa-seedling"></i> Variedades
                    </button>
                    <i class="fas fa-edit" style="cursor:pointer; margin-right: 12px; color: #6b7280;" data-action="edit-safra" data-id="${s.id}" title="Editar"></i>
                    <i class="fas fa-trash" style="color:red; cursor:pointer;" data-action="delete-safra" data-id="${s.id}" title="Excluir"></i>
                </td>
            </tr>
        `).join('');

        container.innerHTML = `
            <div class="data-table-container">
                <div class="action-bar">
                    <div></div>
                    <button class="btn btn-primary" id="btn-nova-safra">+ Nova Safra</button>
                </div>
                <table class="data-table">
                    <thead><tr><th>Ano/Ciclo</th><th>Cultura</th><th>Área (ha)</th><th>Descrição</th><th style="text-align:right;"></th></tr></thead>
                    <tbody>${rows}</tbody>
                </table>
            </div>
            <div id="modal-container-safra"></div>
        `;

        // Listeners
        container.querySelectorAll('[data-action="edit-safra"]').forEach(btn => {
            btn.addEventListener('click', (e) => this.openEditarSafraModal(parseInt(e.target.dataset.id)));
        });

        // Delete Logic
        container.querySelectorAll('[data-action="delete-safra"]').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                const id = parseInt(e.target.dataset.id);
                if (confirm("Excluir esta safra?")) {
                    const { error } = await window.FazendaRP.supabase.from('safras').delete().eq('id', id);
                    if (error) window.FazendaRP.Toast.show('error', 'Erro', error.message);
                    else {
                        window.FazendaRP.Toast.show('success', 'Sucesso', 'Safra removida.');
                        this.renderListaSafras(container);
                    }
                }
            });
        });

        // Variedades Button Logic
        container.querySelectorAll('[data-action="variedades-safra"]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const safraId = parseInt(e.currentTarget.dataset.id);
                const ano = e.currentTarget.dataset.ano;
                const cultura = e.currentTarget.dataset.cultura;
                const areaTotal = parseFloat(e.currentTarget.dataset.area);
                this.openVariedadesModal(safraId, ano, cultura, areaTotal);
            });
        });

        // Create Logic
        document.getElementById('btn-nova-safra').onclick = () => {
            const mc = document.getElementById('modal-container-safra');
            mc.innerHTML = `
                <div class="modal-overlay" id="overlay-safra">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title">Nova Safra</h3>
                            <button class="modal-close" id="close-safra">&times;</button>
                        </div>
                        <div class="form-group" style="margin-bottom:15px">
                            <label>Ano / Ciclo (ex: 23/24)</label>
                            <input id="safra-ano" class="form-control" style="width:100%" placeholder="23/24">
                        </div>
                        <div class="form-group" style="margin-bottom:15px">
                            <label>Cultura Principal</label>
                            <input id="safra-cultura" class="form-control" style="width:100%" placeholder="Soja">
                        </div>
                        <div class="form-group" style="margin-bottom:15px">
                            <label>Área Plantada (ha)</label>
                            <input id="safra-area" type="number" step="0.01" class="form-control" style="width:100%" placeholder="0.00">
                        </div>
                         <div class="form-group" style="margin-bottom:15px">
                            <label>Descrição Opcional</label>
                            <input id="safra-desc" class="form-control" style="width:100%" placeholder="Safra de Verão">
                        </div>
                        <button class="btn btn-primary" id="btn-save-safra" style="width:100%; margin-top:10px;">Salvar</button>
                    </div>
                </div>`;

            document.getElementById('close-safra').onclick = () => mc.innerHTML = '';
            document.getElementById('overlay-safra').onclick = (e) => { if (e.target.id === 'overlay-safra') mc.innerHTML = ''; };

            document.getElementById('btn-save-safra').onclick = async () => {
                const ano = document.getElementById('safra-ano').value;
                const cult = document.getElementById('safra-cultura').value;
                const area = document.getElementById('safra-area').value;
                const desc = document.getElementById('safra-desc').value;

                if (!ano || !cult) {
                    window.FazendaRP.Toast.show('warning', 'Atenção', 'Preencha Ano e Cultura.');
                    return;
                }

                const btn = document.getElementById('btn-save-safra'); btn.disabled = true; btn.innerHTML = 'Salvando...';

                const { error } = await window.FazendaRP.supabase.from('safras').insert([{
                    ano: ano,
                    cultura: cult,
                    area_plantada: area ? parseFloat(area) : null,
                    descricao: desc
                }]);

                if (error) {
                    window.FazendaRP.Toast.show('error', 'Erro', error.message);
                    btn.disabled = false; btn.innerHTML = 'Salvar';
                } else {
                    window.FazendaRP.Toast.show('success', 'Sucesso', 'Safra criada!');
                    mc.innerHTML = '';
                    this.renderListaSafras(container);
                }
            };
        };
    },


    openEditarSafraModal: async function (id) {
        const { data: safra, error } = await window.FazendaRP.supabase
            .from('safras').select('*').eq('id', id).single();

        if (error || !safra) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Safra não encontrada.');
            return;
        }

        const mc = document.getElementById('modal-container-safra');
        mc.innerHTML = `
            <div class="modal-overlay" id="overlay-safra">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Editar Safra</h3>
                        <button class="modal-close" id="close-safra">&times;</button>
                    </div>
                    <div class="form-group" style="margin-bottom:15px">
                        <label>Ano / Ciclo</label>
                        <input id="safra-ano" class="form-control" style="width:100%" value="${safra.ano}">
                    </div>
                    <div class="form-group" style="margin-bottom:15px">
                        <label>Cultura Principal</label>
                        <input id="safra-cultura" class="form-control" style="width:100%" value="${safra.cultura}">
                    </div>
                    <div class="form-group" style="margin-bottom:15px">
                        <label>Área Plantada (ha)</label>
                        <input id="safra-area" type="number" step="0.01" class="form-control" style="width:100%" value="${safra.area_plantada || ''}">
                    </div>
                     <div class="form-group" style="margin-bottom:15px">
                        <label>Descrição</label>
                        <input id="safra-desc" class="form-control" style="width:100%" value="${safra.descricao || ''}">
                    </div>
                    <button class="btn btn-primary" id="btn-upd-safra" style="width:100%; margin-top:10px;">Salvar Alterações</button>
                </div>
            </div>`;

        document.getElementById('close-safra').onclick = () => mc.innerHTML = '';
        document.getElementById('overlay-safra').onclick = (e) => { if (e.target.id === 'overlay-safra') mc.innerHTML = ''; };

        document.getElementById('btn-upd-safra').onclick = async () => {
            const payload = {
                ano: document.getElementById('safra-ano').value,
                cultura: document.getElementById('safra-cultura').value,
                area_plantada: document.getElementById('safra-area').value ? parseFloat(document.getElementById('safra-area').value) : null,
                descricao: document.getElementById('safra-desc').value
            };

            const btn = document.getElementById('btn-upd-safra'); btn.disabled = true; btn.innerHTML = 'Salvando...';

            const { error } = await window.FazendaRP.supabase.from('safras').update(payload).eq('id', id);

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', error.message);
                btn.disabled = false; btn.innerHTML = 'Salvar Alterações';
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Safra atualizada!');
                mc.innerHTML = '';
                this.renderListaSafras(document.getElementById('sistema-content'));
            }
        };
    },

    // --- SUB-TELA: Usuarios (Mantido Mock) ---
    getUsuariosData: function () {
        return JSON.parse(localStorage.getItem('usuarios_sistema')) || [{ id: 1, nome: 'Administrador', email: 'admin@fazenda.com', perfil: 'Admin' }];
    },

    salvarUsuariosData: function (d) {
        localStorage.setItem('usuarios_sistema', JSON.stringify(d));
    },

    renderListaUsuarios: function (container) {
        const users = this.getUsuariosData();
        const rows = users.map(u => `<tr><td>${u.nome}</td><td>${u.perfil}</td><td>Ativo</td><td style="text-align:right;"><i class="fas fa-trash" style="color:#ccc; cursor:not-allowed;"></i></td></tr>`).join('');

        container.innerHTML = `
            <div style="margin-bottom: 15px; color: var(--text-muted); font-size: 0.9rem;">
                Gerenciamento de Acesso
            </div>
            <div class="data-table-container">
                <table class="data-table">
                    <thead><tr><th>Nome</th><th>Perfil</th><th>Status</th><th>Ações</th></tr></thead>
                    <tbody>${rows}</tbody>
                </table>
            </div>
            <div style="margin-top:20px; text-align:center; color:#999; font-style:italic;">
                <i class="fas fa-info-circle"></i> O gerenciamento completo de usuários será ativado na próxima etapa.
            </div>
        `;
    },

    // --- SECÇÃO DE BACKUP ---
    renderBackupSection: function (container) {
        container.innerHTML = `
            <div class="card" style="max-width: 800px; margin: 0 auto; padding: 40px; text-align: center;">
                <div style="font-size: 3rem; color: #0ea5e9; margin-bottom: 20px;">
                    <i class="fas fa-cloud-download-alt"></i>
                </div>
                <h3 style="color: #374151; margin-bottom: 15px;">Backup dos Dados</h3>
                <p style="color: #6b7280; font-size: 1.1rem; margin-bottom: 30px; line-height: 1.6;">
                    Gere um arquivo JSON contendo todos os registros essenciais do seu sistema 
                    (Parceiros, Financeiro, Safras, Estoque, etc).<br>
                    Isso garante que você tenha uma cópia de segurança local de todas as informações.
                </p>
                
                <div style="display: flex; justify-content: center; gap: 20px;">
                    <button id="btn-gerar-backup" class="btn btn-primary" style="padding: 15px 30px; font-size: 1.1rem; display: flex; align-items: center; gap: 10px; background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%); border: none; box-shadow: 0 4px 6px -1px rgba(14, 165, 233, 0.4);">
                        <i class="fas fa-download"></i> Baixar Backup Completo (.JSON)
                    </button>
                    <!-- Future: Restore Button -->
                </div>
                
                <div id="backup-status" style="margin-top: 25px; color: #64748b;"></div>
            </div>
        `;

        document.getElementById('btn-gerar-backup').onclick = () => this.gerarBackupJSON();
    },

    gerarBackupJSON: async function () {
        const btn = document.getElementById('btn-gerar-backup');
        const status = document.getElementById('backup-status');

        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Gerando arquivo...';
        status.innerText = "Coletando dados do servidor...";

        try {
            const tables = [
                'parceiros', 'empresas', 'safras',
                'financeiro_contas', 'financeiro_plano_contas', 'financeiro_lancamentos', 'financeiro_movimentacoes',
                'financeiro_extratos', 'financeiro_pre_lancamentos', 'financeiro_cartoes_faturas',
                'frota', 'maquinas_abastecimentos', 'maquinas_manutencao',
                'suprimentos_itens', 'estoque_movimentacoes'
            ];
            const backupData = {
                metadata: {
                    generated_at: new Date().toISOString(),
                    version: '1.0',
                    app: 'FazendaRP'
                },
                data: {}
            };

            for (const table of tables) {
                status.innerText = `Baixando tabela: ${table}...`;
                const { data, error } = await window.FazendaRP.supabase.from(table).select('*');
                if (error) console.warn(`Erro ao baixar ${table}:`, error);
                backupData.data[table] = data || [];
            }

            // Create File
            const jsonStr = JSON.stringify(backupData, null, 2);
            const blob = new Blob([jsonStr], { type: "application/json" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `backup_fazenda_${new Date().toISOString().slice(0, 10)}.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            status.innerHTML = `<span style="color: #10b981;"><i class="fas fa-check"></i> Backup baixado com sucesso! (${(jsonStr.length / 1024).toFixed(2)} KB)</span>`;
            window.FazendaRP.Toast.show('success', 'Backup', 'Download iniciado com sucesso.');

        } catch (e) {
            console.error(e);
            status.innerHTML = `<span style="color: #ef4444;">Erro ao gerar backup: ${e.message}</span>`;
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao gerar backup.');
        } finally {
            btn.disabled = false;
            btn.innerHTML = '<i class="fas fa-download"></i> Baixar Backup Completo (.JSON)';
        }
    }
};
